import React, { useEffect, useState } from 'react';
import FormModal from '../../Modals/FormModal';
import PaymentMethodSection from './sections/PaymentMethodSection';
import PaymentMethodTable from './sections/PaymentMethodTable';
import PaymentSummaryTotals from './sections/PaymentSummaryTotals';

import { useMultiplePayment } from '../../../hooks/sale/useMultiplePayment';
import { useSale } from '../../../hooks/sale/useSale';

interface MultiplePaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  customerName?: string;
}

const MultiplePaymentModal: React.FC<MultiplePaymentModalProps> = ({
  isOpen,
  onClose,
  customerName = '',
}) => {
  const title = `FORMA DE PAGO MÚLTIPLE${
    customerName ? `: ${customerName}` : ''
  }`;

  const { getAvailableMethods, fetchPayments } = useMultiplePayment();
  const { form } = useSale();

  const [editingPayment, setEditingPayment] = useState<any | null>(null);

  useEffect(() => {
    if (isOpen && form?.id) {
      getAvailableMethods();
      fetchPayments(form.id);
    }
  }, [isOpen, form?.id]);

  // 🔒 Al cerrar el modal, salir de cualquier edición en curso
  useEffect(() => {
    if (!isOpen) {
      setEditingPayment(null);
    }
  }, [isOpen]);

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth="max-w-6xl"
    >
      <div className="flex flex-col gap-6">
        {/* 🔝 HEADER → RESUMEN */}
        <PaymentSummaryTotals />

        {/* 🔽 CONTENIDO PRINCIPAL */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 🧾 IZQUIERDA → INPUTS */}
          <div className="lg:col-span-4">
            <PaymentMethodSection
              editingPayment={editingPayment}
              onDoneEditing={() => setEditingPayment(null)}
            />
          </div>

          {/* 📊 DERECHA → TABLA */}
          <div className="lg:col-span-8">
            <PaymentMethodTable onEdit={setEditingPayment} />
          </div>
        </div>
      </div>
    </FormModal>
  );
};

export default MultiplePaymentModal;
